export const EDIT_SIGNATURE_MODAL = 'EDIT_SIGNATURE_MODAL'
export const DELETE_SIGNATURE_MODAL = 'DELETE_SIGNATURE_MODAL'

export const CONNECT_EMAIL = 'CONNECT_EMAIL'
export const CONFIRM_EMAIL = 'CONFIRM_EMAIL'
export const DELETE_EMAIL_CONNECTION = 'DELETE_EMAIL_CONNECTION'
export const SYNC_EMAIL_CONNECTION = 'SYNC_EMAIL_CONNECTION'
export const RECONNECT_EMAIL_CONNECTION = 'RECONNECT_EMAIL_CONNECTION'
export const BOARD_CONTACT_MODAL = 'BOARD_CONTACT_MODAL'

export const ADD_LABEL_TO_EMAIL_MODAL = 'ADD_LABEL_TO_EMAIL_MODAL'
export const ADD_LABEL_TO_SMS_MODAL = 'ADD_LABEL_TO_SMS_MODAL'

export const NEW_LABEL_MODAL = 'NEW_LABEL_MODAL'
export const CONNECT_CASE_TO_EMAIL_MODAL = 'CONNECT_CASE_TO_EMAIL_MODAL'
export const CONNECT_CASE_TO_EMAIL_MODAL_NOT_ALLOWED =
  'CONNECT_CASE_TO_EMAIL_MODAL_NOT_ALLOWED'
export const CONNECT_CASE_TO_SMS_MODAL = 'CONNECT_CASE_TO_SMS_MODAL'
export const CONNECT_CASE_TO_SMS_MODAL_NOT_ALLOWED =
  'CONNECT_CASE_TO_SMS_MODAL_NOT_ALLOWED'
export const CONNECT_CASE_TO_MESSAGE_MODAL = 'CONNECT_CASE_TO_MESSAGE_MODAL'
export const DELETE_EMAILS_MODAL = 'DELETE_EMAILS_MODAL'
export const DELETE_SMS_MODAL = 'DELETE_SMS_MODAL'

export const FIND_RECIPIENTS_MODAL = 'FIND_RECIPIENTS_MODAL'

export const DECLINE_NEW_OWNER_MODAL = 'DECLINE_OWNER_MODAL'

export const SEEN_BY_MODAL = 'SEEN_BY_MODAL'

export const MOVE_TO_INBOX_FROM_JUNK_MAIL_MODAL =
  'MOVE_TO_INBOX_FROM_JUNK_MAIL_MODAL'
export const DELETE_FROM_JUNK_MAIL_MODAL = 'DELETE_FROM_JUNK_MAIL_MODAL'

export const DIGITAL_KEY_DOOR_OWNERS_MODAL = 'DIGITAL_KEY_OWNERS_MODAL'
export const DIGITAL_KEY_OWNER_ACCESS_MODAL = 'DIGITAL_KEY_OWNER_ACCESS_MODAL'

/**
 *
 * BOARD MEETINGS
 *
 */
export const CREATE_BOARD_CASE = 'CREATE_BOARD_CASE_MODAL'
export const CREATE_NEW_BOARD_CASE_MODAL = 'CREATE_NEW_BOARD_CASE_MODAL'
export const DELETE_BOARD_CASES = 'DELETE_BOARD_CASES_MODAL'
export const GET_ALL_ACTIVE_CASES_MODAL = 'GET_ALL_ACTIVE_CASES_MODAL'
export const CONNECT_BOARD_CASE_TO_MEETING =
  'CONNECT_BOARD_CASE_TO_MEETING_MODAL'

export const PROCESS_DECISION_CASE_MODAL = 'PROCESS_DECISION_CASE_MODAL'
export const PROCESS_ORIENTATION_CASE_MODAL = 'PROCESS_ORIENTATION_CASE_MODAL'
export const POSTPONE_CASE_WARNING = 'POSTPONE_CASE_WARNING'
export const UPLOAD_ATTACHMENT_TO_CASE_MODAL = 'UPLOAD_ATTACHMENT_TO_CASE_MODAL'

export const CONFIRM_SAVE_ALERT_MODAL = 'CONFIRM_SAVE_ALERT_MODAL'
export const CONFIRM_SAVE_NOTICE_MODAL = 'CONFIRM_SAVE_NOTICE_MODAL'
export const EDIT_NOTICE_ALERTS_MODAL = 'EDIT_NOTICE_ALERTS_MODAL'

export const SEND_MEETING_PARTICIPANT_NOTICE_MODAL =
  'SEND_MEETING_PARTICIPANT_NOTICE_MODAL'
export const ADD_MEETING_PARTICIPANTS_MODAL = 'ADD_MEETING_PARTICIPANTS_MODAL'
export const OVERTAKE_MEETING_MODAL = 'OVERTAKE_MEETING_MODAL'
export const CANCEL_MEETING_MODAL = 'CANCEL_MEETING_MODAL'
export const REVERT_CASE_TO_NEW_MODAL = 'REVERT_CASE_TO_NEW_MODAL'
export const COMPLETE_MEETING_MODAL = 'COMPLETE_MEETING_MODAL'
export const START_OVERDUE_MEETING_MODAL = 'START_OVERDUE_MEETING_MODAL'

export const CREATE_MEETING_MODAL = 'CREATE_MEETING_MODAL'

export const PURCHASE_CARBON_FOOTPRINT_MODAL = 'PURCHASE_CARBON_FOOTPRINT_MODAL'

/**
 * Insurance
 */
export const REPORT_DAMAGES_MODAL_CREATE = 'REPORT_DAMAGES_MODAL_CREATE'
export const REPORT_DAMAGES_MODAL_UPDATE = 'REPORT_DAMAGES_MODAL_UPDATE'
export const REPORT_DAMAGES_MODAL_DELETE = 'REPORT_DAMAGES_MODAL_DELETE'
export const REPORT_DAMAGES_MODAL_UNIT = 'REPORT_DAMAGES_MODAL_UNIT'
export const REPORT_DAMAGES_MODAL_BUILDING = 'REPORT_DAMAGES_MODAL_BUILDING'
export const REPORT_DAMAGES_MODAL_SUBMIT = 'REPORT_DAMAGES_MODAL_SUBMIT'
export const REPORT_DAMAGES_PICK_INSURANCE_OBJECT =
  'REPORT_DAMAGES_PICK_INSURANCE_OBJECT'
export const REPORT_DAMAGES_MODAL_ADVISOR_APPROVE =
  'REPORT_DAMAGES_MODAL_ADVISOR_APPROVE'
export const REPORT_DAMAGES_MODAL_ADVISOR_REJECT =
  'REPORT_DAMAGES_MODAL_ADVISOR_REJECT'

/**
 * Contacts
 **/
export const EDIT_COHABITANT_MODAL = 'EDIT_COHABITANT_MODAL'

/**
 * Budget
 **/
export const BUDGET_ADD_BUDGET_LINE = 'BUDGET_ADD_BUDGET_LINE'
